import { DestinationDto } from '@/features/dashboard/tours/types/DestinationDto.ts';
import { getCountryName } from '@/utils/countryUtils.ts';
import { DisplayParts } from '@/utils/formatters.ts';

/** Miasto i kraj osobno — w tabeli kraj idzie wyszarzony. */
export const splitDestination = (
  destination: DestinationDto,
): DisplayParts => ({
  main: destination.city,
  secondary: `, ${getCountryName(destination.country)}`,
});

export const formatDestination = (
  destination: DestinationDto | null | undefined,
): string =>
  destination
    ? `${destination.city}, ${getCountryName(destination.country)}`
    : '';

export const formatDestinationFull = (
  destination: DestinationDto | null | undefined,
): string => {
  if (!destination) return '';
  return [
    destination.street,
    [destination.postalCode, destination.city].filter(Boolean).join(' '),
    getCountryName(destination.country),
  ]
    .filter(Boolean)
    .join(', ');
};
